import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";
import { DevisCTA } from "@/components/DevisCTA";
import { Building2, Route, Square, Sparkles, ShieldCheck } from "lucide-react";

const prestations = [
  { icon: Building2, title: "Façades", text: "Nettoyage haute pression et traitement adapté." },
  { icon: Route, title: "Allées & cours", text: "Nettoyage et remise en état des surfaces extérieures." },
  { icon: Square, title: "Terrasses", text: "Nettoyage de différentes surfaces selon leur nature." },
  { icon: Sparkles, title: "Anti-mousse", text: "Traitement adapté contre les mousses et salissures." },
  { icon: ShieldCheck, title: "Hydrofuge", text: "Protection des surfaces lorsque le support et le produit utilisé le permettent." },
];

export default function Nettoyage() {
  return (
    <div data-testid="nettoyage-page">
      <Seo title="Nettoyage extérieur — Façades, terrasses, anti-mousse | Sandro Services 06 (06)" description="Nettoyage de façades, allées, cours et terrasses, nettoyage haute pression, traitement anti-mousse et hydrofuge dans les Alpes-Maritimes." />
      <PageHero chapter="Nettoyage extérieur" title="Nettoyage extérieur" subtitle="Retrouvez des extérieurs propres, entretenus et protégés.">
        <div className="mt-8 relative h-[300px] md:h-[420px] rounded-2xl overflow-hidden grain shadow-soft">
          <img src="https://images.pexels.com/photos/14965464/pexels-photo-14965464.jpeg?auto=compress&cs=tinysrgb&w=1600" alt="Nettoyage haute pression" className="w-full h-full object-cover" />
        </div>
      </PageHero>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-14 md:py-20">
        <Reveal><h2 className="font-display text-3xl md:text-4xl text-forest">Nos prestations</h2></Reveal>
        <Stagger className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" stagger={0.08}>
          {prestations.map((p) => (
            <StaggerItem key={p.title} className="group bg-white border border-line rounded-2xl p-8 hover:shadow-soft hover:-translate-y-1 transition-all duration-300">
              <div className="w-12 h-12 rounded-full bg-sand-100 grid place-items-center text-olive group-hover:bg-olive group-hover:text-white transition-colors">
                <p.icon size={22} />
              </div>
              <h3 className="mt-6 font-display text-2xl text-forest">{p.title}</h3>
              <p className="mt-3 text-sm text-ink-soft leading-relaxed">{p.text}</p>
            </StaggerItem>
          ))}
        </Stagger>
      </section>

      <DevisCTA title="Redonnez de l'éclat à vos surfaces." />
    </div>
  );
}
